import { ResizeObserver } from '@juggle/resize-observer';
import ClientCheckout from '../client-checkout';
import { getParentPageUrl } from '../common';
import ParentPage from '../parent-page/parent-page';
import Sentry from '../sentry';
import ButtonImpressionLog from './button-impression-log';
import IframeUI from './iframe-ui';
import SelectedVariant from './selected-variant';

(() => {
  // Setup Env
  const windowData = window.__DATA__;
  const parentPageUrl = getParentPageUrl();
  const sentry = Sentry({
    sentryDSN: windowData.sentryDSN,
    parentPageUrl,
  });

  // Setup Model
  const parentPage = new ParentPage('button', windowData.instanceId);
  const checkout = ClientCheckout({ parentPage, sentry });
  checkout.frameLoaded();
  const selectedVariant = new SelectedVariant(windowData, parentPage);
  const buttonImpressionLog = new ButtonImpressionLog(
    windowData,
    parentPage,
    selectedVariant
  );

  window.addEventListener(
    'message',
    (ev) => {
      if (!ev.data.meta?.type) {
        return;
      }

      if (ev.data.meta.type === 'CLICK') {
        const button = document.querySelector('.purple-dot-button');
        selectedVariant.quantity = ev.data.data?.quantity ?? 1;
        button.click();
      }

      if (ev.data.meta.type === 'NOTIFY_ME_CLICK') {
        const notifyMeBtn = document.querySelector('#notify-me');
        notifyMeBtn.click();
      }

      if (ev.data.meta.type === 'LEARN_MORE_CLICK') {
        const button = document.querySelector('.learn-more');
        button.click();
      }
    },
    false
  );

  // Setup UI
  const ui = new IframeUI(windowData, checkout, selectedVariant, parentPage);
  checkout.attachListener(ui);
  selectedVariant.attachListener(ui);
  selectedVariant.attachListener(buttonImpressionLog);

  // Start
  sentry.init();
  ui.start();
  buttonImpressionLog.onUIStarted();
  startResizeObserver(windowData);
})();

function startResizeObserver(windowData) {
  const elem = document.body;

  const resizeObserver = new ResizeObserver(() => {
    window.parent.postMessage(
      {
        meta: {
          placementType: 'button',
          instanceId: windowData.instanceId,
          type: 'window-size-changed',
        },
        data: {
          width: elem.offsetWidth,
          height: elem.offsetHeight,
        },
      },
      '*'
    );
  });

  resizeObserver.observe(elem);
}
